import { createAppTranslation } from '@fiverr-private/i18n-react';
import copies from '../copies.json';

export const { AppI18n, appTranslate, hasAppTranslation } = createAppTranslation(copies, 'identification_marketplace');

export type CopyKey = Parameters<typeof appTranslate>[0];
